var render, staticRenderFns
import script from "./chatTabs.vue?vue&type=script&lang=js"
export * from "./chatTabs.vue?vue&type=script&lang=js"
import style0 from "./chatTabs.vue?vue&type=style&index=0&id=d81969ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81969ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d81969ce')) {
      api.createRecord('d81969ce', component.options)
    } else {
      api.reload('d81969ce', component.options)
    }
    
  }
}
component.options.__file = "src/packages/MChat/chatTabs.vue"
export default component.exports